/**
 * How many images each listing brings back in feed-style queries (search results,
 * collections). Cards let the user swipe through these without opening the listing.
 *
 * Every extra image adds a JSON record with its variant URLs to the response, so this is a
 * deliberate trade between swipeable depth and payload size. The image *files* are still
 * lazy-loaded per slide, so raising this costs bytes of metadata, not bandwidth.
 */
export const FEED_IMAGE_LIMIT = 5;
